export default __webpack_public_path__ + "static/media/applyOnline.9dfc8cf4.svg";